export const INFO_DETAILS_COMPANY = "INFO_DETAILS_COMPANY";
export const INFO_DETAILS_COMPANY_SUCCESS = "INFO_DETAILS_COMPANY_SUCCESS";
export const INFO_DETAILS_COMPANY_ERROR = "INFO_DETAILS_COMPANY_ERROR";